<template>
  <ModalBase @close-modal="close" show-modal narrow auto-h class="survey-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:title>
          <span>{{ reportModalTitle }}</span>
          <div class="answer-list-wrap">
            <ul :key="answerkey" class="answer-list">
              <li v-for="(answer, index) in compAnswers" :key="'answer-' + index" :class="getAnswerClass(answer.id)">
                <div class="answer-list--question">{{ answer.question }}:</div>
                <div class="answer-list--answer">
                  <font-awesome-icon v-if="answer.value === 'true'" icon="fa-solid fa-check" />
                  <font-awesome-icon v-else-if="answer.value === 'false'" icon="fa-solid fa-xmark" />
                  <div v-else>{{ answer.value }}</div>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <SurveyStep @next-step="nextStep()" @prev-step="prevStep()" @save-answer="saveAnswer" :step-data="currentStep" :key="currentStepIdx" />
    </template>

    <template v-slot:actions>
      <hr>
      <div class="survey-modal-footer">
        <GekkoButton
          @click="close"
          :text="$gettext('Cancel')"
          variant="link"
          class="text-danger"
        />
        <div>
          <small>
            {{ pageNumber }}
          </small>
        </div>
        <GekkoButton
          @click="submit"
          :text="$gettext('Generate report')"
          :disabled="!isComplete"
          icon="fa-solid fa-chart-column"
          class="generate-report-btn"
        />
      </div>
    </template>

  </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";

import SurveyStep from "@/components/ui/survey/SurveyStep"

import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"
import CostService from "@/store/services/cost.service";
import TripService from "@/store/services/trip.service";

export default {
  name: 'SurveyModal',
  components: {
    ModalBase, TitleBar, GekkoButton, SurveyStep
  },
  data () {
    return {
      currentStepIdx: 0,
      answers: [],
      answerkey: 0,
      km_total: 0,
      km_private: 0,
      car_costs: 0,
      reverse_charge_total: 0,
      reverse_charge_total_count: 0,
      startDate: null,
      endDate: null,
      steps: [
        {
          type: "question",
          id: 'treat_non_dutch_as_dutch',
          question: {
            text: ""
          }
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      reportInitialValues: "taxreports/getReportInitialValues",
      currentCompany: "main/getCurrentCompany",
      visitingCompanyId: 'main/getVisitingCompanyId',
      getCompanyId: 'main/getCompanyId'
    }),
    pageNumber(){
      var text = this.$gettext('Step %{stepNumber} of %{stepTotal}');
      text = text.replace("%{stepNumber}", this.currentStepIdx + 1);
      text = text.replace("%{stepTotal}", this.steps.length);
      return text;
    },
    reportModalTitle () {
      let title = ''
      let selectedPeriod = ''
      if (this.reportInitialValues.month) {
        const date = new Date();
        // const locale = navigator.language || navigator.userLanguage;
        date.setMonth(this.reportInitialValues.month - 1)
        selectedPeriod = date.toLocaleString(this.$language.current, { month: 'short' })
      } else {
        selectedPeriod = this.reportInitialValues.quarter
      }
      title = this.$gettext('Report for %{period} %{year}')
      title = this.$gettextInterpolate(title, { period: selectedPeriod, year: this.reportInitialValues.year } )
      return title
    },
    isFullYear () {
      return (this.reportInitialValues.month && this.reportInitialValues.month === 12 || this.reportInitialValues.quarter && this.reportInitialValues.quarter === 'Q4')
    },
    currentStep () {
      return this.steps[this.currentStepIdx]
    },
    compAnswers () {
      return Object.values(this.answers)
    },
    isComplete () {
      return (this.currentStepIdx + 1) === this.steps.length
    },
  },
  mounted () {
    document.body.classList.add('modal-on');
  },
  created () {
    var params = {
      company_profile:this.currentCompany.id,
      year: this.reportInitialValues.year,
      owner_company:this.currentCompany.id,
      start_date:this.reportInitialValues.year + "-01-01",
      end_date:this.reportInitialValues.year + "-12-31",
      transport_type: 'car'
    };
    let km_total = TripService.getTotalKmBusiness(params);
    let km_private = TripService.getTotalKmPrivate(params);
    params = {
      owner_company: this.getCompanyId,
      cost_type__default_name: 'car',
      start_date:this.reportInitialValues.year + "-01-01",
      end_date:this.reportInitialValues.year + "-12-31",
      transport_type: 'car'
    };
    let car_costs = CostService.totalNet(params);
    this.setupDates();
    params = {
      owner_company: this.getCompanyId,
      start_date: this.startDate,
      end_date: this.endDate,
      tax_exempt: false,
      tax_exists: false
    };
    let reverse_charge_total = CostService.total(params);
    let reverse_charge_total_count = CostService.count(params);
    Promise.all([
      km_total,
      km_private,
      car_costs,
      reverse_charge_total,
      reverse_charge_total_count,
    ]).then((responses) => {
      this.km_total = responses[0].data
      this.km_private = responses[1].data
      this.car_costs = Math.floor(responses[2].data)
      this.reverse_charge_total = Math.floor(responses[3].data)
      this.reverse_charge_total_count = this.$gettext("divided over %[i] entries.").replace('%[i]', responses[4].data)
      this.initSteps()
    })
  },
  methods: {
    getDaysInMonth(year, month) {
      var d = new Date(year, month, 0).getDate();
      return d;
    },
    setupDates() {
      if (this.reportInitialValues.month != null) {
        this.startDate = this.reportInitialValues.year + '-' + this.reportInitialValues.month + '-' + 1;
        this.endDate = this.reportInitialValues.year + '-' + this.reportInitialValues.month + '-' + this.getDaysInMonth(this.reportInitialValues.year, this.reportInitialValues.month);
      } else {
        var q = this.reportInitialValues.quarter;
        const quarter = q.split("Q")[1];
        var endMonth = quarter * 3;
        this.startDate = this.reportInitialValues.year + '-' + (endMonth - 2) + '-' + 1
        this.endDate = this.reportInitialValues.year + '-' + endMonth + '-' + this.getDaysInMonth(this.reportInitialValues.year, endMonth);
      }
    },
    close () {
      document.body.classList.remove('modal-on');
      if (this.$route.path.includes('control-panel'))
          this.$router.push({ name: 'ControlPanelVAT', params: {customerId: this.visitingCompanyId} })
      else
          this.$router.push({ name: 'TaxreportList' })
    },
    submit () {
      this.$emit('submit', Object.values(this.answers));
    },
    nextStep () {
      if (this.currentStepIdx < (this.steps.length - 1)) this.currentStepIdx++
    },
    prevStep () {
      if (this.currentStepIdx > 0) this.currentStepIdx--
    },
    getAnswerClass (answerId) {
      let answerClass = ''
      const subAnswerIds = ['import_inside_eu', 'import_outside_eu', 'gift_paid', 'car_net', 'car_vat', 'private_expenses_net', 'private_expenses_vat']
      if (subAnswerIds.includes(answerId)) {
        answerClass = 'subanswer'
      }
      return answerClass
    },
    saveAnswer (option) {
      const new_answer = {
        id: option.id,
        question: option.text,
        value: option.value
      }
      this.$set(this.answers, option.id, new_answer)
    },
    initSteps () {
      let small_business_discount = 'false'
      if (this.reportInitialValues.year <= 2019) {
        small_business_discount = 'true'
      }
      const new_answer = {
        id: 'small_business_discount',
        question: this.$gettext('Small Business discount'),
        value: small_business_discount
      }
      this.$set(this.answers, 'small_business_discount', new_answer)

      this.steps = [
        {
          type: 'question',
          id: 'treat_non_dutch_as_dutch',
          question: {
            text: this.$gettext('Do you want to declare VAT from non-Dutch customers to the Belastingdienst?'),
            short_text: this.$gettext('Treat non-Dutch customers as Dutch'),
            extra_info: this.$gettext('This only affects non-Dutch customers that paid Dutch VAT. For smaller businesses it is recommended to declare the VAT collected to the Dutch Belastingdienst'),
            type: 'choose-one',
            options: [
              { text: this.$gettext('Yes'), value: 'true', fn: { name: 'nextStep' } },
              { text: this.$gettext('No'), value: 'false', fn: { name: 'nextStep' } },
            ]
          }
        },
        {
          type: 'question',
          id: 'import_without_vat',
          question: {
            text: this.$gettext('Do you have any goods or services being imported from abroad for which you paid no VAT?'),
            short_text: this.$gettext('Goods/services imported?'),
            type: 'choose-one',
            options: [
              {
                text: this.$gettext('Yes'),
                value: 'true',
                fn: {
                  name: 'loadSubstep',
                  params: {
                    component: {
                      name: 'GoodsImported',
                      data: {
                        reverse_charge_total: this.reverse_charge_total,
                        reverse_charge_total_count: this.reverse_charge_total_count
                      }
                    }
                  }
                }
              },
              {
                text: this.$gettext('No'),
                value: 'false',
                fn: {
                  name: 'nextStep'
                }
              },
            ]
          }
        },
        {
          type: 'question',
          id: 'over_gift_limit',
          question: {
            text: this.$gettext('Did you give more than 227 EUR (ex VAT) in representational gifts to a single person in one year?'),
            short_text: this.$gettext('Gifts exceed €227?'),
            type: 'choose-one',
            options: [
              {
                text: this.$gettext('Yes'),
                value: 'true',
                fn: {
                  name: 'loadSubstep',
                  params: {
                    component: {
                      name: 'GiftsExceed'
                    }
                  }
                }
              },
              { text: this.$gettext('No'), value: 'false', fn: { name: 'nextStep' } },
            ]
          }
        },
        {
          type: 'message',
          nextbutton: this.$gettext('I Understand'),
          question: {
            text: this.$gettext('Important notice: the kleine ondernemersregeling is no longer applicable in 2020 if you pay VAT. If you are part of the new kleine ondernemingsregeling you do not have to report VAT to the Belastingdienst. Please check with the Belastingdienst whether this rule applies to you.'),
          }
        }
      ]
      const fullYearSteps = [
        {
          type: 'question',
          id: 'private_car_costs',
          question: {
            text: this.$gettext('Would you like to adjust the VAT amount in car costs to reflect private use?'),
            short_text: this.$gettext('Private use of car?'),
            type: 'choose-one',
            options: [
              {
                text: this.$gettext('Yes'),
                value: 'true',
                fn: {
                  name: 'loadSubstep',
                  params: {
                    component: {
                      name: 'PrivateCarCosts',
                      data: {
                        km_business: this.km_total - this.km_private,
                        km_private: this.km_private,
                        km_total: this.km_total,
                        car_costs: this.car_costs
                      }
                    }
                  }
                }
              },
              {
                text: this.$gettext('No'),
                value: 'false',
                fn: {
                  name: 'nextStep'
                }
              },
            ]
          }
        },
        {
          type: 'question',
          id: 'private_expenses',
          question: {
            text: this.$gettext('Do you have any private expenses?'),
            short_text: this.$gettext('Private expenses?'),
            type: 'choose-one',
            options: [
              {
                text: this.$gettext('Yes'),
                value: 'true',
                fn: {
                  name: 'loadSubstep',
                  params: {
                    component: {
                      name: 'PrivateExpenses'
                    }
                  }
                }
              },
              {
                text: this.$gettext('No'),
                value: 'false',
                fn: {
                  name: 'nextStep'
                }
              },
            ]
          }
        },
        {
          type: 'message',
          question: {
            text: this.$gettext('A correction report will also be calculated. Corrections include any data that has not been reflected in previous reports.'),
          }
        },
      ]
      const partialFinalStep = [
        {
          type: 'message',
          question: {
            text: this.$gettext('We have all the required information, press Generate Report to complete the process.'),
          }
        },
      ]
      if (this.isFullYear) {
        this.steps.push(...fullYearSteps)
      } else {
        this.steps.push(...partialFinalStep)
      }
    }
  }
}
</script>

<style lang="scss">
.survey-modal {

  .survey-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .gk-modal-wrapper {
    .gk-modal {
      .titlebar.title-modal {
        h2 {
          font-size: 22px;
          width: 100%;
        }
        .title-wrap {
          .pagetitle {
            width: 100%;
            &--main { width: 100%; }
          }
          .action-bar { display: none; }
        }
      }
      .action-buttons-wrapper.has-actions {
        padding-top: 0;
      }
    }
  }
  .answer-list-wrap {
    font-size: 16px;
    padding: 0.5rem;
    padding-top: 1rem;
    .answer-list {
      list-style: none;
      margin: 0;
      padding: 0;
      font-family: DINNextLTPro-Medium, sans-serif;
      .subanswer {
        font-size: 14px;
        .answer-list--question, .answer-list--answer {
          font-family: DINNextLTPro-Regular, sans-serif;
        }
      }
      li {
        &:not(:last-child) {
          margin-bottom: 0.5rem
        }
        display: flex;
        gap: 1rem;
      }
      &--question {
        flex: 1;
        text-align: right;
      }
      &--answer {
        flex: 1;
        text-align: left;
      }
    }
  }
  .generate-report-btn {
    &.disabled {
      opacity: 0.3 !important;
      filter: grayscale(1);
    }
  }
}

</style>
